import React from 'react';
import { FaFacebook, FaGithub, FaLinkedin, FaInstagram } from "react-icons/fa";

const Footer = () => {
    return (
        <footer className="mt-auto sticky bottom-0 bg-slate-50 dark:bg-slate-900 z-20 flex justify-center md:justify-between px-8 py-2 ">
            <div className="hidden md:block">
                <span className="text-sm text-gray-500 sm:text-center dark:text-[#E9F8F9]">
                    <span className="text-xl">©</span> 2024{" "}
                    {/* <a href="https://flowbite.com/" className="hover:underline">
                        Nabil Ahmed Nahid
                    </a> */}
                    Nabil Ahmed Nahid. All rights reserved.
                </span>
            </div>
            <ul className="flex flex-wrap items-center text-base text-gray-800 dark:text-[#E9F8F9] sm:mt-0 pt-2">
                <li>
                    <a
                        href="https://www.linkedin.com/in/nabil-ahmed-nahid/"
                        rel="noreferrer"
                        target="_blank"
                        className="mr-10"
                    >
                        <FaLinkedin />
                    </a>
                </li>
                <li>
                    <a
                        href="https://github.com/nabilAhmedN"
                        rel="noreferrer"
                        target="_blank"
                        className="mr-10"
                    >
                        <FaGithub />
                    </a>
                </li>
                <li>
                    <a
                        href="https://www.facebook.com/nabilAhmedNahid2"
                        rel="noreferrer"
                        target="_blank"
                        className="mr-10"
                    >
                        <FaFacebook />
                    </a>
                </li>
                <li>
                    <a
                        href="https://www.instagram.com/nabil_astro_b"
                        rel="noreferrer"
                        target="_blank"
                        className="mr-10"
                    >
                        <FaInstagram />
                    </a>
                </li>
            </ul>
        </footer>
    );
};

export default Footer;